module.exports = __webpack_public_path__ + "static/media/dark-paths.7d917551.png";